import { map } from "rxjs/operators";

import { getBetasAsObservable } from "./betas.helpers";

export const hasBetaObs = (beta) => {
  return getBetasAsObservable().pipe(map((betas) => betas.includes(beta)));
};
